import { Configuration, SkusApi } from '@/api';
import { SkuFilters } from '@/api/SkusApi';
import { ProductVariantSelectItem } from '@/components/ProductVariantSelectBox';
import { productVariantSelectBoxQueryKey } from '@/components/productVariantSelectBoxQueryKey';
import ChecklistComboBox from '@/components/select/ChecklistComboBox';
import { ChecklistComboBoxProps } from '@/components/select/ComboBox';
import { SkuAssociation } from '@/models/Sku';
import { useAuth } from '@/modules/auth/contexts/AuthContext';

interface ProductVariantChecklistComboBoxProps extends Omit<
  ChecklistComboBoxProps<ProductVariantSelectItem>,
  'queryFn' | 'queryKey'
> {
  supplierId?: string;
  productListId?: string;
}

const ProductVariantChecklistComboBox = ({
  supplierId,
  productListId,
  label = 'Products:',
  placeholder = 'Search products',
  ...props
}: ProductVariantChecklistComboBoxProps) => {
  const skusApi = new SkusApi(new Configuration(useAuth));

  const findAvailableSkus = async (query: string = ''): Promise<ProductVariantSelectItem[]> => {
    const filters: Partial<SkuFilters> = { supplierId };

    if (productListId) {
      filters.productListId = productListId;
      filters.exclude = true;
    }

    const response = await skusApi.findSkus(query, filters, 0, 10, undefined, [
      SkuAssociation.PRODUCT,
    ]);

    return response.items.map((sku) => ({
      id: sku.id,
      name: sku.externalCode ? `${sku.name} (${sku.externalCode})` : sku.name,
      sku,
    }));
  };

  return (
    <ChecklistComboBox<ProductVariantSelectItem>
      {...props}
      name="sku"
      label={label}
      placeholder={placeholder}
      queryFn={findAvailableSkus}
      queryKey={productVariantSelectBoxQueryKey(supplierId, productListId)}
    />
  );
};

export default ProductVariantChecklistComboBox;
